import { useSelector } from 'react-redux'
import { RootState } from 'types'
import { isEqual } from 'lodash'

/**
 * Returns the auth or the unregistered user.
 * Useful for cases where you do not care if the user
 * is unregistered or not (i.e. workflows that allow unregistered users).
 */
export const useAuthOrUnregisteredUser = () => {
  const result = useSelector(
    (state: RootState) => ({
      user: state.auth ?? state.unregisteredUser.user,
      isRegistered: !!state.auth,
    }),
    isEqual,
  )
  return result
}
